import { gql } from "@apollo/client";

export const GET_FLOORING_CURSOR = gql`
  query FlooringsCursor(
    $text: String
    $first: Int!
    $after: String
    $where: QueryFlooringsCursorWhereWhereConditions
    $whereStandTypeFlooring: QueryFlooringsCursorWhereStandTypeFlooringWhereHasConditions
    $whereExhibitionTypeFlooring: QueryFlooringsCursorWhereExhibitionTypeFlooringWhereHasConditions
    $stand_type_group: ID
    $orderBy: [QueryFlooringsCursorOrderByOrderByClause!]
  ) {
    flooringsCursor(
      text: $text
      first: $first
      after: $after
      where: $where
      whereStandTypeFlooring: $whereStandTypeFlooring
      whereExhibitionTypeFlooring: $whereExhibitionTypeFlooring
      orderBy: $orderBy
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        total
        count
        currentPage
        lastPage
      }
      edges {
        cursor
        node {
          id
          title
          article
          type
          color
          standTypeDefault(stand_type_group: $stand_type_group)
          images {
            id
            extension
            description
            field_group
            order
            server_name
            sizes
            title
          }
          supplier {
            id
            title
          }
        }
      }
    }
  }
`;

export const GET_FLOORING = gql`
  query GetFlooring($id: ID) {
    flooring(id: $id) {
      id
      title
      article
      type
      color
      images {
        id
        extension
        description
        field_group
        order
        server_name
        sizes
        title
      }
      supplier {
        id
        title
      }
    }
  }
`;

export const GET_FLOORING_VARIATIONS = gql`
  query GetFlooringVariations(
    $text: String
    $first: Int
    $page: Int
    $where: QueryFlooringVariationsWhereWhereConditions
    $orderBy: [QueryFlooringVariationsOrderByOrderByClause!]
  ) {
    flooringVariations(
      text: $text
      first: $first
      page: $page
      where: $where
      orderBy: $orderBy
    ) {
      paginatorInfo {
        total
        count
        currentPage
        perPage
        lastPage
      }
      data {
        id
        title
        article
        flooring_id
        organizer_id
        price
        price_basic
        created_at
        updated_at
        relFlooring {
          id
          title
        }
        relOrganizer {
          id
          title
        }
      }
    }
  }
`;

export const GET_FLOORING_VARIATION = gql`
  query GetFlooringVariation($id: ID) {
    flooringVariation(id: $id) {
      id
      title
      article
      flooring_id
      organizer_id
      price
      price_basic
      created_at
      updated_at
      relFlooring {
        id
        title
      }
      relOrganizer {
        id
        title
      }
    }
  }
`;
